import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [identifier, setIdentifier] = useState('');
  const [accountEmail, setAccountEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSendOtp = async () => {
    const normalizedIdentifier = identifier.trim();
    setMessage('');
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/customers/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: normalizedIdentifier }),
      });
      const data = await res.json();
      if (res.ok && data.exists !== false) {
        setIdentifier(normalizedIdentifier);
        setAccountEmail(data.accountEmail || normalizedIdentifier.toLowerCase());
        setMessage(data.message || 'OTP sent successfully. Please check your inbox and spam folder.');
        setStep(2);
      } else {
        setStep(1);
        setAccountEmail('');
        setError(data.error || data.message || 'We could not send the reset code right now.');
      }
    } catch (err) {
      console.error(err);
      setError('Could not connect to the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setMessage('');
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/customers/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          identifier: accountEmail || identifier.trim(),
          otp: otp.trim(),
          newPassword,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        const unified = {
          id: data.customer?._id || data.customer?.id,
          _id: data.customer?._id || data.customer?.id,
          name: data.customer?.name,
          email: data.customer?.email,
          phone: data.customer?.phone,
          token: data.token,
        };
        localStorage.setItem('customer', JSON.stringify(unified));
        setMessage('Password updated successfully. Signing you in...');
        setTimeout(() => {
          const redirectTo = sessionStorage.getItem('redirectAfterLogin');
          sessionStorage.removeItem('redirectAfterLogin');
          navigate(redirectTo || '/');
        }, 2000);
      } else {
        setError(data.error || data.message || 'Failed to reset password');
      }
    } catch (err) {
      console.error(err);
      setError('Could not reset the password right now. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 460, margin: 'auto', padding: 24 }}>
      <h2>Reset Your Password</h2>
      <p style={{ color: '#64748b', marginTop: 0 }}>
        Enter your registered email address or phone number. We will send a 6-digit OTP to your account email so you can reset your password securely.
      </p>
      {message && <p style={{ color: 'green' }}>{message}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {step === 1 ? (
        <>
          <input
            type="text"
            placeholder="Enter your registered email or phone"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            autoComplete="username"
            style={{ width: '100%', marginBottom: 10, padding: 8 }}
          />
          <button onClick={handleSendOtp} disabled={loading || !identifier.trim()} style={{ width: '100%', padding: 10 }}>
            {loading ? 'Sending OTP...' : 'Send OTP'}
          </button>
        </>
      ) : (
        <>
          <p style={{ color: '#64748b', fontSize: 14 }}>
            We sent a reset code to <strong>{accountEmail}</strong>. Check your inbox and spam folder.
          </p>
          <div style={{ width: '100%', marginBottom: 10, padding: 8, border: '1px solid #cbd5e1', borderRadius: 4, background: '#f8fafc', color: '#475569' }}>
            Account lookup: {identifier}
          </div>
          <input
            type="text"
            placeholder="Enter 6-digit OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            style={{ width: '100%', marginBottom: 10, padding: 8 }}
          />
          <input
            type="password"
            placeholder="Create new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{ width: '100%', marginBottom: 10, padding: 8 }}
          />
          <button
            onClick={handleResetPassword}
            disabled={loading || !otp.trim() || newPassword.length < 6}
            style={{ width: '100%', padding: 10, marginBottom: 10 }}
          >
            {loading ? 'Updating Password...' : 'Reset Password'}
          </button>
          <button
            type="button"
            onClick={handleSendOtp}
            disabled={loading}
            style={{ width: '100%', padding: 10, background: '#fff', border: '1px solid #cbd5e1' }}
          >
            Resend OTP
          </button>
          <button
            type="button"
            onClick={() => {
              setStep(1);
              setAccountEmail('');
              setOtp('');
              setNewPassword('');
              setMessage('');
              setError('');
            }}
            disabled={loading}
            style={{ width: '100%', padding: 10, marginTop: 10, background: '#fff', border: '1px solid #cbd5e1' }}
          >
            Change Email
          </button>
        </>
      )}
    </div>
  );
};

export default ForgotPassword;
